import { ChakraProps } from "@chakra-ui/react"
import useBimData from "../../../common/hooks/useBimData"
import { useBrandedTranslation } from "../../../common/hooks/useBrandedTranslation"
import DownloadButton from "../../shared/DownloadButton/DownloadButton"

type Props = ChakraProps & {
  productKey: string
  locale: string
}

export default function DownloadBimButton({ productKey, locale, ...rest }: Props) {
  const { isLoading: isBimDownloadUrlLoading, bimDownloadUrl, downloadBimUrl } = useBimData(productKey, locale)
  const { t } = useBrandedTranslation()
  return (
    <>
      {(isBimDownloadUrlLoading || bimDownloadUrl) && (
        <DownloadButton
          isLoading={isBimDownloadUrlLoading}
          onClick={downloadBimUrl}
          label={t("pdp-downloadBim")}
          {...rest}
        />
      )}
    </>
  )
}
